import React, { useState } from 'react';

const essentialsOptions = ['Fruits', 'Vegetables', 'Dairy', 'Bakery', 'Sweets', 'Non-Veg'];
const budgets = [49, 99, 149, 199, 249, 299, 349, 399, 449, 499, 749, 999, 1499, 1999, 2499];
const qualityOptions = ['Seller’s Best', 'Balanced', 'Budget Saver'];
const prepOptions = ['Whole', 'Fresh Cut', 'Ready-to-Cook'];

const dummyPlaceholderPhotos = [
  'https://via.placeholder.com/300x300/0891b2/ffffff?text=Kit+Photo+1',
  'https://via.placeholder.com/300x300/067399/ffffff?text=Kit+Photo+2',
];

const SantulitHome = () => {
  // Demo role switcher (remove in real app when auth is implemented)
  const [role, setRole] = useState('customer'); // 'customer' or 'seller'

  // Customer state
  const [myKits, setMyKits] = useState([
    {
      id: 'kit1',
      title: 'Morning Essentials',
      essentials: ['Fruits', 'Vegetables', 'Dairy'],
      preparation: 'Whole',
      budget: 299,
      quality: 'Balanced',
      fulfilment: { type: 'Home Delivery', expectedTime: 'Next day morning' },
      pincode: '400001',
      neighborhood: 'Colaba',
    },
    {
      id: 'kit2',
      title: 'Family Weekly',
      essentials: ['Vegetables', 'Dairy', 'Bakery', 'Non-Veg'],
      preparation: 'Fresh Cut',
      budget: 749,
      quality: 'Seller’s Best',
      fulfilment: { type: 'Pickup', expectedTime: 'Tomorrow evening' },
      pincode: '400001',
      neighborhood: 'Colaba',
    },
  ]);

  const [myOrders, setMyOrders] = useState([
    {
      id: 'order1',
      kit: myKits[0],
      status: 'Ready',
      sellerName: 'Ramesh Fresh Mart',
      remarks: 'Added extra bananas as requested',
      photos: dummyPlaceholderPhotos,
    },
    {
      id: 'order2',
      kit: myKits[1],
      status: 'Accepted',
      sellerName: 'Ramesh Fresh Mart',
      remarks: '',
      photos: [],
    },
  ]);

  // Seller state
  const [incomingOrders, setIncomingOrders] = useState([
    {
      id: 'inc1',
      customerName: 'Asha Patel',
      kit: {
        budget: 199,
        essentials: ['Fruits', 'Vegetables'],
        fulfilment: { type: 'Home Delivery', expectedTime: 'Next day' },
      },
    },
    {
      id: 'inc2',
      customerName: 'Priya Sharma',
      kit: {
        budget: 499,
        essentials: ['Dairy', 'Bakery', 'Sweets'],
        fulfilment: { type: 'Pickup', expectedTime: 'Tomorrow' },
      },
    },
  ]);

  const [inProgressOrders, setInProgressOrders] = useState([
    {
      id: 'prog1',
      customerName: 'Vikram Singh',
      kit: {
        budget: 349,
        essentials: ['Vegetables', 'Dairy', 'Non-Veg'],
      },
      status: 'Accepted',
      remarks: '',
      photos: [],
    },
  ]);

  // Create Kit form state
  const [createKitForm, setCreateKitForm] = useState({
    essentials: [],
    preparation: null,
    budget: 199,
    quality: 'Balanced',
    fulfilment: { type: 'Home Delivery', expectedTime: 'Next day morning' },
    pincode: '400001',
    neighborhood: 'Colaba',
  });
  const [createMessage, setCreateMessage] = useState('');

  // Shared feedback
  const [feedback, setFeedback] = useState('');

  // Customer actions
  const handleCreateKit = (e) => {
    e.preventDefault();
    const newKit = {
      id: 'kit' + Date.now(),
      title: 'My New Kit',
      ...createKitForm,
    };
    setMyKits([...myKits, newKit]);
    setCreateMessage('Kit created successfully!');
    setTimeout(() => setCreateMessage(''), 3000);
  };

  const handlePlaceOrder = (kit) => {
    const newOrder = {
      id: 'order' + Date.now(),
      kit,
      status: 'Placed',
      sellerName: null,
      remarks: '',
      photos: [],
    };
    setMyOrders([...myOrders, newOrder]);
    setFeedback('Order placed! It will appear in local sellers\' dashboards.');
    setTimeout(() => setFeedback(''), 4000);

    // Simulate broadcast to seller view
    setIncomingOrders([
      ...incomingOrders,
      {
        id: 'inc' + Date.now(),
        customerName: 'You (Demo Customer)',
        kit: {
          budget: kit.budget,
          essentials: kit.essentials,
          fulfilment: kit.fulfilment,
        },
      },
    ]);
  };

  // Seller actions
  const handleAcceptOrder = (orderId) => {
    const order = incomingOrders.find((o) => o.id === orderId);
    setIncomingOrders(incomingOrders.filter((o) => o.id !== orderId));
    setInProgressOrders([
      ...inProgressOrders,
      { ...order, status: 'Accepted', remarks: '', photos: [] },
    ]);
    setFeedback('Order accepted and locked!');
    setTimeout(() => setFeedback(''), 3000);
  };

  const handleMarkReady = (orderId) => {
    const remarks = prompt('Add remarks (optional):') || '';
    const photos = dummyPlaceholderPhotos;
    setInProgressOrders(
      inProgressOrders.map((o) =>
        o.id === orderId ? { ...o, status: 'Ready', remarks, photos } : o
      )
    );
    setFeedback('Order marked as Ready with photos!');
    setTimeout(() => setFeedback(''), 3000);
  };

  const handleMarkReplenished = (orderId) => {
    setInProgressOrders(
      inProgressOrders.map((o) =>
        o.id === orderId ? { ...o, status: 'Replenished' } : o
      )
    );
    setFeedback('Order completed!');
    setTimeout(() => setFeedback(''), 3000);
  };

  // Customer tabs
  const [customerTab, setCustomerTab] = useState('kits');

  return (
    <div className="min-h-screen bg-black text-cyan-300">
      {/* Header */}
      <div className="bg-gray-950 py-2 text-center border-b border-blue-600">
        <h1 className="text-xl lg:text-2xl font-bold text-cyan-400">
          🛍️ Santulit 🍎🥬
        </h1>
        <p className="mt-2 text-xs lg:text-lsm text-cyan-200">Daily Essentials Kits for Your Neighborhood</p>
      </div>

      {/* Demo Role Switcher */}
      <div className="bg-gray-900 p-4 flex justify-center gap-8 text-lg">
        <button
          onClick={() => setRole('customer')}
          className={`bg-teal-800 pb-2 px-2 py-1 text-xs w-24 lg:w-32 lg:text-sm rounded font-medium ${role === 'customer' ? 'border-b-4 border-cyan-600' : ''}`}
        >
          Customer View
        </button>
        <button
          onClick={() => setRole('seller')}
          className={`bg-blue-800 pb-2 px-2 py-1 text-xs w-24 lg:w-32 lg:text-sm rounded font-medium ${role === 'seller' ? 'border-b-4 border-cyan-600' : ''}`}
        >
          Seller View
        </button>
      </div>

      {feedback && (
        <div className="bg-cyan-900 p-4 text-center text-cyan-200 font-medium">
          {feedback}
        </div>
      )}

      {/* CUSTOMER VIEW */}
      {role === 'customer' && (
        <>
          {/* Customer Tabs */}
          <div className="bg-gray-900 p-4 flex justify-around text-lg">
            <button
              onClick={() => setCustomerTab('kits')}
              className={`bg-teal-600 pb-2 px-2 py-1 text-xs w-24 lg:w-32 lg:text-sm rounded font-medium ${customerTab === 'kits' ? 'border-b-4 border-cyan-600' : ''}`}
            >
              My Kits
            </button>
            <button
              onClick={() => setCustomerTab('create')}
              className={`bg-teal-600 pb-2 px-2 py-1 text-xs w-24 lg:w-32 lg:text-sm rounded font-medium ${customerTab === 'create' ? 'border-b-4 border-cyan-600' : ''}`}
            >
              Create Kit
            </button>
            <button
              onClick={() => setCustomerTab('orders')}
              className={`bg-teal-600 pb-2 px-2 py-1 text-xs w-24 lg:w-32 lg:text-sm rounded font-medium ${customerTab === 'orders' ? 'border-b-4 border-cyan-600' : ''}`}
            >
              My Orders
            </button>
          </div>

          {/* My Kits */}
          {customerTab === 'kits' && (
            <div className="p-2 space-y-6">
              <h2 className="text-lg lg:text-xl text-cyan-400">My Santulit Kits</h2>
              {myKits.length === 0 ? <p>No kits yet. Create one!</p> : null}
              {myKits.map((kit) => (
                <div
                  key={kit.id}
                  className="bg-gray-900 p-2 rounded-lg flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4"
                >
                  <div className='[&_p]:text-white'>
                    <p className="text-xl font-semibold">{kit.title || 'My Kit'}</p>
                    <p>₹{kit.budget} | {kit.essentials.join(', ')}</p>
                    <p className="text-sm text-cyan-200">
                      {kit.fulfilment.type} – {kit.fulfilment.expectedTime}
                    </p>
                  </div>
                  <button
                    onClick={() => handlePlaceOrder(kit)}
                    className="bg-cyan-600 hover:bg-cyan-700 px-2 py-1 text-xs w-24 lg:w-32 lg:text-sm rounded font-medium"
                  >
                    Place Order
                  </button>
                </div>
              ))}
            </div>
          )}

          {/* Create Kit */}
          {customerTab === 'create' && (
            <div className="p-2">
              <h2 className="text-lg lg:text-xl mb-2 text-cyan-400">Create Your Santulit Kit</h2>
              <form onSubmit={handleCreateKit} className="space-y-6">
                <div>
                  <label className="block mb-2 text-lg">Essentials (select multiple)</label>
                  <div className="grid grid-cols-2 gap-4">
                    {essentialsOptions.map((opt) => (
                      <label key={opt} className="flex items-center text-lg">
                        <input
                          type="checkbox"
                          checked={createKitForm.essentials.includes(opt)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setCreateKitForm({
                                ...createKitForm,
                                essentials: [...createKitForm.essentials, opt],
                              });
                            } else {
                              setCreateKitForm({
                                ...createKitForm,
                                essentials: createKitForm.essentials.filter(
                                  (i) => i !== opt
                                ),
                              });
                            }
                          }}
                          className="mr-3 scale-125"
                        />
                        {opt}
                      </label>
                    ))}
                  </div>
                </div>

                <div>
                  <label className="block mb-2 text-lg">Preparation (optional)</label>
                  <select
                    onChange={(e) =>
                      setCreateKitForm({ ...createKitForm, preparation: e.target.value || null })
                    }
                    className="w-full h-10 p-2 bg-gray-800 rounded text-lg"
                  >
                    <option value="">None</option>
                    {prepOptions.map((p) => (
                      <option key={p} value={p}>
                        {p}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block mb-2 text-lg">Budget</label>
                  <select
                    value={createKitForm.budget}
                    onChange={(e) =>
                      setCreateKitForm({ ...createKitForm, budget: Number(e.target.value) })
                    }
                    className="w-full h-10 p-2 bg-gray-800 rounded text-lg"
                    required
                  >
                    {budgets.map((b) => (
                      <option key={b} value={b}>
                        ₹{b}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block mb-2 text-lg">Quality Preference</label>
                  <select
                    value={createKitForm.quality}
                    onChange={(e) =>
                      setCreateKitForm({ ...createKitForm, quality: e.target.value })
                    }
                    className="w-full h-10 p-2 bg-gray-800 rounded text-lg"
                  >
                    {qualityOptions.map((q) => (
                      <option key={q}>{q}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block mb-2 text-lg">Fulfilment</label>
                  <select
                    onChange={(e) =>
                      setCreateKitForm({
                        ...createKitForm,
                        fulfilment: { ...createKitForm.fulfilment, type: e.target.value },
                      })
                    }
                    className="w-full h-10 p-2 bg-gray-800 rounded text-lg"
                  >
                    <option>Home Delivery</option>
                    <option>Pickup</option>
                  </select>
                  <input
                    placeholder="Expected time (e.g., Next day morning)"
                    value={createKitForm.fulfilment.expectedTime}
                    onChange={(e) =>
                      setCreateKitForm({
                        ...createKitForm,
                        fulfilment: { ...createKitForm.fulfilment, expectedTime: e.target.value },
                      })
                    }
                    className="w-full mt-3 p-3 bg-gray-800 rounded text-lg"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="px-2 py-1 text-xs w-24 lg:w-32 lg:text-sm rounded font-medium bg-cyan-600 hover:bg-cyan-700"
                >
                  Save Kit
                </button>
              </form>
              {createMessage && (
                <p className="mt-6 text-center text-cyan-400 text-lg font-medium">{createMessage}</p>
              )}
            </div>
          )}

          {/* My Orders */}
          {customerTab === 'orders' && (
            <div className="p-2 space-y-6 [&_p]:text-white">
              <h2 className="text-lg lg:text-xl text-cyan-400">My Orders</h2>
              {myOrders.length === 0 ? <p>No orders yet</p> : null}
              {myOrders.map((order) => (
                <div key={order.id} className="bg-gray-900 p-2 rounded-lg">
                  <p className="text-lg">
                    Budget: ₹{order.kit.budget} | {order.kit.fulfilment.type}
                  </p>
                  <p>Essentials: {order.kit.essentials.join(', ')}</p>

                  <div className="mt-4">
                    <p className="text-xl font-bold text-cyan-400">Status: {order.status}</p>
                    <div className="flex justify-between mt-2 text-sm text-cyan-200">
                      <span>Placed</span>
                      <span>Accepted</span>
                      <span>Ready</span>
                      <span>Replenished</span>
                    </div>
                    <div className="relative h-3 bg-gray-700 rounded mt-1">
                      <div
                        className="absolute h-full bg-cyan-600 rounded transition-all"
                        style={{
                          width:
                            order.status === 'Placed'
                              ? '25%'
                              : order.status === 'Accepted'
                              ? '50%'
                              : order.status === 'Ready'
                              ? '75%'
                              : '100%',
                        }}
                      />
                    </div>
                  </div>

                  {order.sellerName && (
                    <p className="mt-4">Seller: {order.sellerName}</p>
                  )}
                  {order.remarks && <p className="mt-2">Remarks: {order.remarks}</p>}
                  {order.photos.length > 0 && (
                    <div className="mt-4 grid grid-cols-2 gap-4">
                      {order.photos.map((url, i) => (
                        <img key={i} src={url} alt={`Kit photo ${i + 1}`} className="rounded" />
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* SELLER VIEW */}
      {role === 'seller' && (
        <div className="p-2 space-y-8 [&_p]:text-white ">
          <h2 className="text-xl lg:text-2xl text-cyan-400 text-center">Seller Dashboard</h2>

          {/* Incoming Orders */}
          <div>
            <h3 className="text-lg lg:text-xl mb-2 text-cyan-400">Incoming Orders (First-come-first-serve)</h3>
            {incomingOrders.length === 0 ? <p>No incoming orders</p> : null}
            {incomingOrders.map((order) => (
              <div key={order.id} className="bg-gray-900 p-2 rounded-lg mb-4">
                <p className="text-lg">Customer: {order.customerName}</p>
                <p>Budget: ₹{order.kit.budget}</p>
                <p>Essentials: {order.kit.essentials.join(', ')}</p>
                <p className="text-sm text-cyan-200">
                  {order.kit.fulfilment.type} – {order.kit.fulfilment.expectedTime}
                </p>
                <button
                  onClick={() => handleAcceptOrder(order.id)}
                  className="mt-5 bg-cyan-600 hover:bg-cyan-700 px-2 py-1 text-xs w-24 lg:w-32 lg:text-sm rounded font-medium"
                >
                  Accept Order
                </button>
              </div>
            ))}
          </div>

          {/* In Progress Orders */}
          <div>
            <h3 className="text-xl md:text-2xl mb-4 text-cyan-400">In Progress Orders</h3>
            {inProgressOrders.length === 0 ? <p>No active orders</p> : null}
            {inProgressOrders.map((order) => (
              <div key={order.id} className="bg-gray-900 p-2 rounded-lg mb-4">
                <p className="text-lg">Customer: {order.customerName}</p>
                <p>Budget: ₹{order.kit.budget}</p>
                <p>Status: <span className="text-cyan-400 font-bold">{order.status}</span></p>

                {order.status === 'Accepted' && (
                  <button
                    onClick={() => handleMarkReady(order.id)}
                    className="mt-5 bg-blue-600 hover:bg-blue-700 px-2 py-1 text-xs w-24 lg:w-32 lg:text-sm rounded font-medium"
                  >
                    Mark Ready (adds dummy photos)
                  </button>
                )}

                {order.status === 'Ready' && (
                  <>
                    {order.remarks && <p className="mt-3">Remarks: {order.remarks}</p>}
                    {order.photos.length > 0 && (
                      <div className="mt-4 grid grid-cols-2 gap-4">
                        {order.photos.map((url, i) => (
                          <img key={i} src={url} alt={`Kit photo ${i + 1}`} className="rounded" />
                        ))}
                      </div>
                    )}
                    <button
                      onClick={() => handleMarkReplenished(order.id)}
                      className="mt-5 bg-teal-600 hover:bg-teal-700 px-2 py-1 text-xs w-24 lg:w-32 lg:text-sm rounded font-medium"
                    >
                      Mark Replenished
                    </button>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SantulitHome;